module.exports = "<p>\r\n  core works!\r\n</p>\r\n"